import type { ReactNode } from 'react';

export type StatusTone = 'ok' | 'warn' | 'bad' | 'info' | 'neutral';

export interface StatusPillProps {
  /** ok = done / confirmed, warn = waiting / needs something, bad = failed / cancelled, info = in progress, neutral = past. */
  tone?: StatusTone;
  /** Always words ("Confirmed", "Waiting for a check"), never colour alone. */
  children: ReactNode;
  /** Small leading dot (default on). */
  dot?: boolean;
}

/** Compact status label in AA colours for both schemes. */
export function StatusPill({ tone = 'info', children, dot = true }: StatusPillProps) {
  return (
    <span className={`rides-pill ${tone}`}>
      {dot && <span className="dot" aria-hidden="true" />}
      {children}
    </span>
  );
}
